<template>
  <div :class="$style.base" v-bind="$attrs">
    <slot />
  </div>
</template>

<style module>
.base {
  margin-top: var(--space-md);
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.18px;
}
</style>
